import { render, staticRenderFns } from "./subTechnicalScoreSummary.vue?vue&type=template&id=2e40b206&scoped=true"
import script from "./subTechnicalScoreSummary.vue?vue&type=script&lang=js"
export * from "./subTechnicalScoreSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e40b206",
  null
  
)

export default component.exports